<!-- Road BoQ list aligned with Project Management dashboard -->
<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">

  <!-- Header -->
  <div class="mb-8">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h1 class="text-3xl font-bold text-gray-900 mb-2">
          Road BoQ &amp; BOM Management
        </h1>
        <p class="text-gray-600">
          Manage Bill of Quantities and Bill of Materials for road projects
        </p>
      </div>

      <div class="flex flex-wrap gap-4">
        <div class="bg-white rounded-lg px-4 py-3 shadow-sm border border-gray-200">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
              </svg>
            </div>
            <div>
              <p class="text-sm text-gray-600">Total Road BoQs</p>
              <p class="text-lg font-semibold text-gray-900">{{ totalItems }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filters & actions -->
  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 mb-8">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col xl:flex-row xl:items-center gap-4">
        <!-- Search -->
        <div class="flex-1 min-w-0">
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <input
              type="text"
              [(ngModel)]="searchKeyword"
              (keyup.enter)="applyFilter()"
              placeholder="Search by code, name, or project..."
              class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl leading-5 bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200"
            />
          </div>
        </div>

        <!-- Filters -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 xl:flex xl:flex-nowrap xl:gap-3">
          <select
            [(ngModel)]="selectedAuthority"
            (change)="applyFilter()"
            class="w-full xl:w-64 px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
          >
            <option value="">All Authorities</option>
            <option *ngFor="let authority of administrativeAuthorities" [value]="authority">
              {{ authority }}
            </option>
          </select>
          <select
            [(ngModel)]="selectedStatus"
            (change)="applyFilter()"
            class="w-full xl:w-48 px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
          >
            <option *ngFor="let status of statusOptions" [value]="status.value">{{ status.label }}</option>
          </select>
        </div>
      </div>

      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-2 pt-1 border-t border-gray-100 xl:border-t-0 xl:pt-0">
        <button
          type="button"
          (click)="clearFilters()"
          class="inline-flex items-center px-4 py-2.5 border border-gray-300 text-sm font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-sm"
        >
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          Clear Filters
        </button>
        <button
          type="button"
          (click)="loadRoadBoQs()"
          class="inline-flex items-center px-4 py-2.5 border border-gray-300 text-sm font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-sm"
        >
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Refresh
        </button>
        <button
          type="button"
          (click)="createNew()"
          class="inline-flex items-center px-6 py-2.5 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-lg"
        >
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          New Road BoQ
        </button>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex flex-col items-center justify-center py-20 bg-white rounded-2xl shadow-lg border border-gray-200">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
    <p class="text-gray-600">Loading road BoQs...</p>
  </div>

  <!-- Table -->
  <div *ngIf="!loading" class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
      <h2 class="text-lg font-semibold text-gray-900">Road BoQs overview</h2>
      <p class="text-sm text-gray-600 mt-1">Browse and manage road BoQs and BOM items</p>
    </div>

    <div class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="boq_code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">BoQ Code</th>
          <td mat-cell *matCellDef="let roadBoQ" class="px-6 py-4 whitespace-nowrap">
            <div class="font-medium text-blue-600">{{ roadBoQ.boq_code }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="boq_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">BoQ Name</th>
          <td mat-cell *matCellDef="let roadBoQ" class="px-6 py-4">
            <div class="font-medium text-gray-900">{{ roadBoQ.boq_name }}</div>
            <div class="text-sm text-gray-500" *ngIf="roadBoQ.project_name">{{ roadBoQ.project_name }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="administrative_authority">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Authority</th>
          <td mat-cell *matCellDef="let roadBoQ" class="px-6 py-4">
            <span class="text-sm text-gray-700">{{ roadBoQ.administrative_authority }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="road_type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Road Type</th>
          <td mat-cell *matCellDef="let roadBoQ" class="px-6 py-4 whitespace-nowrap">
            <span class="inline-flex px-2.5 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">
              {{ roadBoQ.road_type }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="specifications">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Specifications</th>
          <td mat-cell *matCellDef="let roadBoQ" class="px-6 py-4">
            <span class="text-sm text-gray-700">{{ getSpecifications(roadBoQ) }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Status</th>
          <td mat-cell *matCellDef="let roadBoQ" class="px-6 py-4 whitespace-nowrap">
            <span [class]="'inline-flex px-2.5 py-1 rounded-full text-xs font-medium ' + getStatusClass(roadBoQ.status)">
              {{ roadBoQ.status | titlecase }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="total_amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Total Amount</th>
          <td mat-cell *matCellDef="let roadBoQ" class="px-6 py-4 whitespace-nowrap">
            <span class="font-semibold text-gray-900">{{ formatCurrency(roadBoQ.total_amount) }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="items">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Items</th>
          <td mat-cell *matCellDef="let roadBoQ" class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm text-gray-600">
              <div>BoQ: {{ roadBoQ.item_count || 0 }}</div>
              <div class="text-gray-500">BOM: {{ roadBoQ.bom_item_count || 0 }}</div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Actions</th>
          <td mat-cell *matCellDef="let roadBoQ" class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center gap-1">
              <button mat-icon-button matTooltip="View Details" (click)="viewDetails(roadBoQ)" class="text-blue-600 hover:bg-blue-50">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Edit" (click)="editRoadBoQ(roadBoQ)" class="text-green-600 hover:bg-green-50">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Delete" (click)="deleteRoadBoQ(roadBoQ)" class="text-red-600 hover:bg-red-50">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-50"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-gray-50 transition-colors duration-150"></tr>
      </table>
    </div>

    <div *ngIf="dataSource.data.length === 0" class="text-center py-12 px-4">
      <div class="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
        </svg>
      </div>
      <h3 class="text-lg font-medium text-gray-900 mb-2">No Road BoQs found</h3>
      <p class="text-gray-500 mb-6">Create your first road BoQ to get started.</p>
      <button
        type="button"
        (click)="createNew()"
        class="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200"
      >
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        Create Road BoQ
      </button>
    </div>

    <div *ngIf="totalItems > 0" class="px-6 py-4 border-t border-gray-200 bg-gray-50">
      <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div class="text-sm text-gray-600">
          Showing {{ pageIndex * pageSize + 1 }} to
          {{ (pageIndex + 1) * pageSize > totalItems ? totalItems : (pageIndex + 1) * pageSize }}
          of {{ totalItems }} road BoQs
        </div>
        <mat-paginator
          [length]="totalItems"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageSizeOptions]="pageSizeOptions"
          [showFirstLastButtons]="true"
          (page)="onPageChange($event)"
          class="bg-transparent"
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>
